
import { studentInfoType, scoreType } from '../../types'

const makeArr = (scores: studentInfoType[] ) => {

    const arr = [] as string[][]
    const res = [] as scoreType[]

    for(let i = 0; i < scores.length; i++) {

        arr.push([]);

        const lessontype = scores[i].lessontype;
        const author     = scores[i].author;
        const grades     = scores[i].grades;
        const str        = scores[i].answers;

        let amp = false;
        let counter = 0;

        for (let j = 0; j < str.length; j++) {

            if (!str.length) {
                break;
            }
            
            if (amp) {
                if (str[j] === '#' && str[j+1]) {
                    const val = str[j+1];
                    arr[i].push(val)
                    if (val === '1') {
                        counter++
                    }
                    amp = false
                }
            }
            if (str[j] === '@' && str[j+1]) {
                if (str[j+1] === 'g') {
                    arr[i].push('g')
                    amp = false
                }
                else {
                    amp = true;
                }
            }
        }

        if (arr[i].length) {
            res.push({ 
                lessontype: lessontype,
                author:     author, 
                grades:     grades,
                scores:     arr[i],
                correct:    counter ? Math.round((counter / arr[i].length) * 100) : 0
            })
        }
    }

    return res;
}


export const results = (scores: studentInfoType[]) => {

    let smallArr: any = [];
    let bigArr: any = [];

    if (scores.length === 1) {
        bigArr = [makeArr([scores[0]])]
        return bigArr
    }

    for (let i = 0; i < scores.length; i++) {
        
        const last = i === scores.length-1;

        if ( !i ) {
            smallArr.push(scores[i])
        }
        else if (!last) {
            if (scores[i].lessontype === scores[i-1].lessontype) {
                smallArr.push(scores[i])
            }
            else {
               bigArr.push(makeArr(smallArr))
               smallArr = [scores[i]];
            }
        }
        else {
            if (scores[i].lessontype === scores[i-1].lessontype) {
                smallArr.push(scores[i])
                bigArr.push(makeArr(smallArr))
            }
            else {
               bigArr.push(makeArr(smallArr))
               bigArr.push(makeArr([scores[i]]))
            }
        }
    }

    return bigArr
}








